import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-39",
  "use": "icon-icon-nav-39-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-39\"><path d=\"M832 263.104v234.304L725.312 390.4 583.104 532.992 440.96 390.784 298.688 532.992 192 425.984V263.04C192 224 224 192 263.104 192h497.792C800 192 832 224 832 263.104z m-106.688 228.288L832 598.4v162.496C832 800 800 832 760.896 832H263.04C224 832 192 800 192 760.896V526.912l106.688 106.304 142.208-142.208L583.04 633.216l142.208-141.824z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-39.svg
// module id = dt8N
// module chunks = 3